var appid = '56CC095378589F7998EE1331E25C01A6';
var vn = '嘟嘟巴士包车H5端';
var vc = '1.0';
var TDBaseUrl = 'https://jic.talkingdata.com/app/h5/v1/websdk';
var TDRequestUrl = 'https://h5.udrig.com/app/v1';

function createScriptTd(url) {
  var _head = document.getElementsByTagName('head')[0];
  var _script = document.createElement('script');
  _script.type = 'text/javascript';
  _script.src = url;
  _head.appendChild(_script)
};
createScriptTd(TDBaseUrl + '/js/sdk_release.js');
if (!window['JSON'] || typeof JSON !== 'object') {
  createScriptTd(TDBaseUrl + '/js/json2.js')
}
window["TDAPP"] = {};
window["TDAPP"].onEvent = function(id, label, params) {
  if (arguments.length > 0) {
    try {
      var opts = {
        count: 1,
        start: new Date().getTime()
      };
      if (id != undefined) {
        opts["id"] = typeof id != "string" ? JSON.stringify(id) : id
      }
      if (label != undefined) {
        opts["label"] = typeof label != "string" ? JSON.stringify(label) : label
      } else {
        opts["label"] = ""
      }
      if (params != undefined) {
        var isJson = function(obj) {
          var isjson = typeof(obj) == "object" && Object.prototype.toString.call(obj).toLowerCase() == "[object object]" && !obj.length;
          return isjson
        };
        if (isJson(params)) {
          opts["params"] = params
        } else {
          opts["params"] = {
            params: ""
          }
        }
      }
      var eventName = "__TD_td-init-event";
      var ev = localStorage[eventName];
      if (ev) {
        var ca = JSON.parse(ev);
        ca.push(opts);
        localStorage.setItem(eventName, JSON.stringify(ca));
        return
      };
      localStorage.setItem(eventName, "[" + JSON.stringify(opts) + "]")
    } catch (e) {}
  }
};
// 导出
window['appid'] = '56CC095378589F7998EE1331E25C01A6';
window['vn'] = '嘟嘟巴士包车H5端';
window['vc'] = '1.0';
window['TDBaseUrl'] = 'https://jic.talkingdata.com/app/h5/v1/websdk';
window['TDRequestUrl'] = 'https://h5.udrig.com/app/v1';



// WEBPACK FOOTER //
// ./src/assets/js/talkingdata.js